import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {OpenInfoComponent} from '@app/open-info/open-info/open-info.component';
import {OpenInfoEquipmentComponent} from '@app/open-info/open-info-equipment/open-info-equipment.component';
import {OpenInfoEquipmentGuard} from '@shared/guards/open-info-equipment.guard';

const routes: Routes = [
  {
    path: 'open-info',
    component: OpenInfoComponent,
    data: { title: 'openInfoPage' },
    children: [
      {
        path: 'equipment/:id',
        component: OpenInfoEquipmentComponent,
        canActivate: [OpenInfoEquipmentGuard],
        data: {
          title: 'equipmentOverview',
        }
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OpenInfoRoutingModule { }
